import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UserManagementService } from '../services/user-management.service';
import { User } from '../model/User';
import { Subject } from 'rxjs';


@Component({
    selector: 'app-users-list',
    templateUrl: './users-list.component.html',
    styleUrls: ['./users-list.component.scss'],
    standalone: false
})
export class UsersListComponent implements OnInit {
 
  @Output() userChanged = new EventEmitter<Event>();

  public searchText: string = '';
  public users: User[];
  public selectedUser : any

  constructor
    (
      private _userManagementService: UserManagementService
    ) {
      this._userManagementService.updateUserList$.subscribe(() => {           
        this.getUsersList();
      })   
  }

  ngOnInit(): void {
    this.getUsersList();
  }

  private getUsersList() {
    this._userManagementService.getUsersList()
      .subscribe(res => {        
        this.users = res.result;  
      }, err => {
        console.error(err);
      })
  }

  onSelectUser(user: Event) {
    this.userChanged.emit(user);
    this.selectedUser = user
  }
  
  addNewUser() {
    this._userManagementService.clickedAddNewUser$.next();
  }
}
